import countapi from 'countapi-js'
import React, { Component }  from 'react';

class Counter extends Component {
  state = {
    visitors: 6969,
  }

  componentDidMount(){
    var title = this.props.title.replace(/-|\s/g,"-");
    countapi.visits(title).then((result) => {
      this.setState({visitors: result.value});
    });
  }

  render() {
    return (
      <p>&nbsp;• {this.state.visitors} Visits</p>
    )
  }
}

export default Counter
